module.exports = __webpack_public_path__ + "static/media/camera.10afe7bf.png";